export let markAsUnread = "KF8hFd";
export let markAsUnreadNumberOfConversationsWhenCountIsNegative = "_Tclr";
export let markAsUnreadNumberOfItemsWhenCountIsNegative = "si4fae";
export let markAsUnreadNumberOfConversations = "YiMnbc";
export let markAsUnreadNumberOfItems = "Au5Edd";
export default {markAsUnread,markAsUnreadNumberOfConversationsWhenCountIsNegative,markAsUnreadNumberOfItemsWhenCountIsNegative,markAsUnreadNumberOfConversations,markAsUnreadNumberOfItems};